import { action } from 'services/api';

export const ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR';
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR';
export const REMOVE_SNACKBAR = 'REMOVE_SNACKBAR';

export const enqueueSnackbar = (notification: any) => {
  const key = notification.options && notification.options.key;
  return action(ENQUEUE_SNACKBAR, {
    notification: {
      ...notification,
      key: key || new Date().getTime() + Math.random(),
    },
  });
};

export const closeSnackbar = (key: string | number) =>
  action(CLOSE_SNACKBAR, { dismissAll: !key, key });

export const removeSnackbar = (key: string | number) =>
  action(REMOVE_SNACKBAR, { key });
